module.exports = __webpack_public_path__ + "img/varoszoba_enterior_4.d4596d1b.jpg";